var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavingFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H8.31833C8.63392 0 8.9225 0.178333 9.06367 0.460658L9.66667 1.66667H14.6667C15.1269 1.66667 15.5 2.03977 15.5 2.5V11.6667C15.5 12.1269 15.1269 12.5 14.6667 12.5H9.34833C9.03275 12.5 8.74417 12.3217 8.603 12.0393L8 10.8333H2.16667V15.8333H0.5V0Z",
    fill: "#2C2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingFlag);
export default __webpack_public_path__ + "static/media/waving-flag.21ba2a818a76b29bf716bf896a50da0f.svg";
export { ForwardRef as ReactComponent };